import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function PainSection() {
  return <section className="bg-[#111111] px-5 py-16 md:py-24" data-id="element-161">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-162">
        <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-10" data-id="element-163">
          Si esto te pasa, no estás solo:
        </motion.h2>

        <div className="space-y-6" data-id="element-164">
          <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-165">
            <span className="text-[#E8732A] text-2xl mt-1" data-id="element-166">•</span>
            <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-167">
              Tus videos tienen vistas, likes, guardados…{' '}
              <span className="text-white" data-id="element-168">
                pero las ventas no reflejan nada de eso.
              </span>
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-169">
            <span className="text-[#E8732A] text-2xl mt-1" data-id="element-170">•</span>
            <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-171">
              Te piden info y tú contestas,{' '}
              <span className="text-white" data-id="element-172">pero se desaparecen.</span>
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-173">
            <span className="text-[#E8732A] text-2xl mt-1" data-id="element-174">•</span>
            <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-175">
              Sientes que estás "cerca"…{' '}
              <span className="text-white" data-id="element-176">
                pero nunca llega el click final.
              </span>
            </p>
          </motion.div>
        </div>

        <motion.div variants={itemVariants} className="mt-12 pt-8 border-t border-[#2A2A2A]" data-id="element-177">
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-4" data-id="element-178">
            Y lo más pesado no es el dinero.
          </p>
          <p className="text-white text-xl md:text-2xl font-semibold leading-relaxed mb-6" data-id="element-179">
            Es la sensación de: "¿Estoy perdiendo el tiempo?"
          </p>
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-180">
            Porque por fuera pareces que vas bien (engagement).
            <br data-id="element-181" />
            Pero por dentro sabes la verdad:{' '}
            <span className="text-[#E8732A] font-semibold" data-id="element-182">
              no estás convirtiendo.
            </span>
          </p>
        </motion.div>
      </motion.div>
    </section>;
}